/**
 * 事件触达
 */
import React from 'react';
import styles from './index.module.scss';
import { XSelect, XOKButton, XCancelButton, XInput, XDatePicker, } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import PopconfirmModal from '../../modal/PopconfirmModal';
import model from '@/reducers/market/eventtouch/model';


class Marketing extends React.PureComponent {

    state = {
        periodType: {}, // 事件周期
        status: {},//启用状态
        startTime: undefined,
        endTime: undefined,
        currentOpenMode: '', // 当前需要打开的弹窗signTime
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() {
        const { getEventTouchEnum, getPeriodTypeEnum } = this.props;
        getEventTouchEnum({ enumName: 'CurrentStatusEnum' });//启用状态
        getPeriodTypeEnum({ enumName: 'PeriodTypeEnum' }); // 任务周期
    }

    // 新建攻略
    _createStudioRoom = () => {
        const { history } = this.props;
        history.push({ pathname: '/home/market/eventtouch/createinfo' });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, eventName, periodType, endTime, startTime, status } = this.state;
        const { getEventTriggerByPage, } = this.props;
        this.searchCache = {
            eventName,
            periodType: periodType.code,
            startTime: startTime ? startTime.format('YYYY-MM-DD HH:mm') : undefined,
            endTime: endTime ? endTime.format('YYYY-MM-DD HH:mm') : undefined,
            status: status.code,//启用状态
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        getEventTriggerByPage(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ periodType: {}, status: {}, eventName: undefined, startTime: undefined, endTime: undefined }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
       this.setState({ pageNum, pageSize}, () => {
           this._searchHandle('useCache');
       })
    }


    // 表格操作  
    _tableAction = (id, type, value) => {
        const { history } = this.props;
        switch (type) {
            case 'detail':
                history.push({ pathname: `/home/market/eventtouch/detailinfo/${id}` });
                break;
            case 'switch':// 开启状态
                this.setState({
                    currentOpenMode: 'switch',
                    openModeParam: { ...id, switchState: value ? '1' : '0' },
                });
                break;
            case 'edit':
                history.push({ pathname: `/home/market/eventtouch/editorinfo/${id}` });
                break;
            case 'getDetail'://明细
                {
                    const { couponName, ...restState } = value;
                    http('/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.couponStatistics', { id: item }, 'POST')
                        .then((res = {}) => {
                            this.setState({
                                currentOpenMode: 'data',
                                openModeParam: { ...res.result, couponName, id: item }
                            });
                        }).catch((reject = {}) => {
                            message.error(reject.message);
                        });
                }
                break;
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'switch'://开启状态
                return <PopconfirmModal data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this.props.getEventTriggerByPage(this.searchCache);
        }
    }

    render() {
        const { status, eventName, periodType, startTime, endTime  } = this.state;
        const { EventTriggerByPage, EventTouchEnum, PeriodTypeEnum } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='事件标题'
                                placeholder='请输入事件标题'
                                value={eventName}
                                bindThis={this}
                                bindName='eventName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='事件周期'
                                placeholder='请选择'
                                renderData={PeriodTypeEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={periodType.value}
                                bindThis={this}
                                bindName='periodType'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='执行时间'
                                value={startTime}
                                format="YYYY-MM-DD HH:mm"
                                bindThis={this}
                                bindName='startTime'
                            />
                            <XDatePicker
                                style={{ marginRight: '20px' }}
                                value={endTime}
                                format="YYYY-MM-DD HH:mm"
                                bindThis={this}
                                bindName='endTime'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='状态'
                                placeholder='请选择'
                                renderData={EventTouchEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建事件' onClick={this._createStudioRoom} />
                    </div>
                    <TableContent
                        renderData={EventTriggerByPage}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Marketing.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    updateContent: PropTypes.func, // 路由跳转
    EventTriggerByPage: PropTypes.object,
    getEventTriggerByPage: PropTypes.func,//卡券中心列表数据(action)
    getEventTouchEnum: PropTypes.func,
    EventTouchEnum: PropTypes.array,
    getPeriodTypeEnum: PropTypes.func,
    PeriodTypeEnum: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        EventTriggerByPage: state.eventtouch.EventTriggerByPage,
        EventTouchEnum: state.eventtouch.EventTouchEnum,
        PeriodTypeEnum: state.eventtouch.PeriodTypeEnum
    };
};
export default connect(mapStateToProps, model.actions)(Marketing);
